import React from "react";
import styles from "../Detail.module.scss";
import classNames from "classnames/bind";
import { FaLongArrowAltUp, FaLongArrowAltDown } from "react-icons/fa";

const cx = classNames.bind(styles);

export const Row = ({ label, value, delta, dir }) => (
  <div className={cx("row")}>
    <div className={cx("cellLabel")}>{label}:</div>
    <div className={cx("cellValue")}>{value}</div>
    <div className={cx("status")}>{dir === "up" ? "tăng" : "giảm"}</div>
    <div className={cx("delta", dir === "up" ? "up" : "down")}>
      {delta}
      {dir === "up" ? <FaLongArrowAltUp /> : <FaLongArrowAltDown />}
    </div>
  </div>
);

export const StatsRow = ({ label, value, delta, pct, dir }) => (
  <div className={cx("row")}>
    <div className={cx("cellLabel")}>{label}:</div>
    <div className={cx("cellValue")}>{value}</div>
    <div className={cx("status")}>{dir === "up" ? "tăng" : "giảm"}</div>
    <div className={cx("delta", dir === "up" ? "up" : "down")}>{delta}</div>
    <div className={cx("pct", dir === "up" ? "up" : "down")}>
      {pct ?? "-"}
      {dir === "up" ? <FaLongArrowAltUp /> : <FaLongArrowAltDown />}
    </div>
  </div>
);

